export const calculatePMITerm = (monthPayAmt, loanInterest, loanBaseAmt, nbrMonthsRqstd) => {
   //  the outstanding loan amount returned by this function is equal to the
   //  amount of principal outstanding on a loan after 'x' months of payments 
   //  confirmed this is accurate by using an online calculator  
   //  the result is the same calculcateOutstandingLoanPrincipalAmt function
    let loanBalance = loanBaseAmt;
    let monthlyInterestPct = loanInterest / 12;
    let nbrMonths = 0;
    let percentOutstanding = 100;

    while (percentOutstanding > 80 && nbrMonths < nbrMonthsRqstd) {
        const interestAmt = loanBalance * monthlyInterestPct;
        const principalAmt = monthPayAmt - interestAmt;
        loanBalance = loanBalance - principalAmt;
        percentOutstanding = (loanBalance / loanBaseAmt) * 100;
        nbrMonths++;
    }

    return nbrMonths;
}

